import React from 'react';
import styled from 'styled-components';
import { AlertTriangle, RefreshCw } from 'lucide-react';
import { Button } from '@/common/components/button/Button';
import { useNavigate } from 'react-router-dom';

const ErrorBoundaryFallback: React.FC<{resetError: () => void}> = ({resetError}) => {

  const navigate = useNavigate();

  const handleBack = () => {
    if (resetError) {
      resetError();
    }
    navigate(-1);
  };

  const handleGoHome = () => {
    if (resetError) {
      resetError();
      // resetError 후 약간의 지연을 두고 페이지 이동
      setTimeout(() => {
        window.location.href = '/';
      }, 100);
    } else {
      window.location.href = '/';
    }
  };

  const handleReload = () => {
    if (resetError) {
      resetError();
    }
    window.location.reload();
  };

  return (
    <ErrorContainer>
      <ErrorContent>
        <IconWrapper>
          <AlertTriangle size={48} color="#ff6b6b" />
        </IconWrapper>
        
        <ErrorTitle>문제가 발생했습니다</ErrorTitle>
        <ErrorDescription>
          예상치 못한 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.
        </ErrorDescription>



        <ButtonContainer>
         <Button onClick={handleBack} $size='sm' $variant='outline'>
            이전 페이지
          </Button>
          
          <Button onClick={handleReload} $size='sm' $variant='outline'>
            <RefreshCw size={16} />
            새로고침
          </Button>
          
          <Button onClick={handleGoHome} $size='sm' $variant='fill'>
            홈으로 이동
          </Button>
        </ButtonContainer>
      </ErrorContent>
    </ErrorContainer>
  );
};

const ButtonContainer = styled.div`
	display: flex;
	gap: 10px;
`;

const ErrorContainer = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background-color: #f8f9fa;
`;

const ErrorContent = styled.div`
  max-width: 500px;
  width: 100%;
  text-align: center;
  background: white;
  padding: 40px;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

const IconWrapper = styled.div`
  margin-bottom: 24px;
`;

const ErrorTitle = styled.h1`
  font-size: 24px;
  font-weight: 600;
  color: #333;
  margin-bottom: 16px;
`;

const ErrorDescription = styled.p`
  font-size: 16px;
  color: #666;
  line-height: 1.5;
  margin-bottom: 32px;
`;

export default ErrorBoundaryFallback; 